var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "slideContainer", staticClass: "solvency" },
    [
      _c("Title", {
        attrs: { zhTitle: _vm.pageData.name, enTitle: _vm.pageData.name },
      }),
      _c("div", { staticClass: "cards" }, [
        _vm.zcfzl
          ? _c("div", { staticClass: "card" }, [
              _vm.language === "zh"
                ? _c("div", { staticClass: "zh" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName) + " "
                      ),
                      _c("span", { staticClass: "card-text" }, [
                        _vm._v("资产负债率"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v("\n          " + _vm._s(_vm.zcfzl)),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.zcfzlUnit)),
                      ]),
                    ]),
                  ])
                : _vm.language === "en"
                ? _c("div", { staticClass: "en" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        _vm._s(_vm.jsonData.year) +
                          _vm._s(_vm.periodNameEng) +
                          " "
                      ),
                      _c("span", { staticClass: "card-text" }, [
                        _vm._v("Asset-liability Ratio"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v("\n          " + _vm._s(_vm.zcfzl)),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.zcfzlUnit)),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { ref: "chart1", staticClass: "charts1" }),
            ])
          : _vm._e(),
        _vm.ldbl
          ? _c("div", { staticClass: "card" }, [
              _vm.language === "zh"
                ? _c("div", { staticClass: "zh" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName) + " "
                      ),
                      _c("span", { staticClass: "card-text" }, [
                        _vm._v("流动比率"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.ldbl)),
                    ]),
                  ])
                : _vm.language === "en"
                ? _c("div", { staticClass: "en" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        _vm._s(_vm.jsonData.year) +
                          _vm._s(_vm.periodNameEng) +
                          " "
                      ),
                      _c("span", { staticClass: "card-text" }, [
                        _vm._v("Current Ratio"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.ldbl)),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { ref: "chart2", staticClass: "charts" }),
            ])
          : _vm._e(),
        _vm.sdbl
          ? _c("div", { staticClass: "card" }, [
              _vm.language === "zh"
                ? _c("div", { staticClass: "zh" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName) + " "
                      ),
                      _c("span", { staticClass: "card-text" }, [
                        _vm._v("速动比率"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.sdbl)),
                    ]),
                  ])
                : _vm.language === "en"
                ? _c("div", { staticClass: "en" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        _vm._s(_vm.jsonData.year) +
                          _vm._s(_vm.periodNameEng) +
                          " "
                      ),
                      _c("span", { staticClass: "card-text" }, [
                        _vm._v("Quick Ratio"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.sdbl)),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { ref: "chart3", staticClass: "charts" }),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }